import Timestamp from "components/Timestamp";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import { ManagedUserGroupView } from "../../types";

const IdpGroupMappingTableLastLoginCell = ({
  item: group,
  ...cellProps
}: TableSimpleCellProps<ManagedUserGroupView>) => {
  return (
    <TableSimpleCell {...cellProps}>
      {!group.lastLoginTime && <TableCellEmpty />}
      {group.lastLoginTime && <Timestamp timestamp={group.lastLoginTime} />}
    </TableSimpleCell>
  );
};

export default IdpGroupMappingTableLastLoginCell;
